import UserApi from "./UserApi";
class V3UserApi implements UserApi {
  fetchCustom: (
    url: string,
    options: any,
    addAuthenticationHeader?: boolean
  ) => Promise<any>;

  constructor(
    fetchC: (
      url: string,
      options: any,
      addAuthenticationHeader?: boolean
    ) => Promise<any>
  ) {
    this.fetchCustom = fetchC;
  }

  sendPictureForLicense = (
    customerId: number,
    reservationId: number,
    token: string,
    imageData: string,
    exifData?: any[]
  ): Promise<any> => {
    const fetchUrl = `/customers/me/drivers-license`;
    return this.fetchCustom(
      fetchUrl,
      {
        method: "POST",
        body: JSON.stringify({ photo: imageData, exifData, reservationId })
      },
    );
  };

  sendPictureForUser = (
    customerId: number,
    reservationId: number,
    token: string,
    imageData: string,
    exifData?: any[]
  ): Promise<any> => {
    const fetchUrl = `/customers/me/selfie`;

    return this.fetchCustom(
      fetchUrl,
      {
        method: "POST",
        body: JSON.stringify({ photo: imageData, exifData, reservationId })
      },
    );
  };

  getPictureStatusForUser = (minutes?: number) => {
    const fetchUrl = `/customers/me/photos-stored-count`;
    const suffix = minutes ? `?minutes=${minutes}` : ''

    return this.fetchCustom(
      fetchUrl + suffix, {});
  };

  //create/update user based on phonenumber
  saveUserDetails = (user: any) => {
    const fetchUrl = `/customers`;
    return this.fetchCustom(
      fetchUrl,
      {
        method: "POST",
        body: JSON.stringify(user)
        // body: JSON.stringify({})
      },
    );
  }

  saveUserProfile = (user: any) => {
    const fetchUrl = `/customers/me`;
    return this.fetchCustom(
      fetchUrl,
      {
        method: "PATCH",
        body: JSON.stringify(user)
        // body: JSON.stringify({})
      },
    );
    // return new Promise((resolve, reject) => reject('API saveUserProfile Endpoint not implemented yet'));
  };

  applyUserCoupon = (coupon: string) => {
    return new Promise((resolve, reject) =>
      reject("API applyUserCoupon Endpoint not implemented yet")
    );
  };

  fetchUser = (token?: string, jwt?: string) => {

    if (!token || !jwt) {
      return this.fetchCustom("/customers/me", {});
    }

    return this.fetchCustom('/customers/me', {
      headers: {
        Authorization: "Bearer " + token,
        jwt
      }
    }, false);
  };

  fetchUserHash = (token?: string, jwt?: string) => {

    if (!token || !jwt) {
      return this.fetchCustom("/customers/me/hash", {
        method: "POST",});
    }

    return this.fetchCustom('/customers/me/hash', {
      method: "POST",
       headers: {
        Authorization: "Bearer " + token,
        jwt
      }
    }, false);
  };

  fetchUserPhoto = () => {
    return new Promise((resolve, reject) =>
      reject("API fetchUserPhoto Endpoint not implemented yet")
    );
  };

  fetchLicensePhoto = () => {
    return new Promise((resolve, reject) =>
      reject("API fetchLicensePhoto Endpoint not implemented yet")
    );
  };

  sendVerificationEmail = () => {
    return this.fetchCustom(
      "/customers/me/verify?reservation_id=210071",
      { method: "POST" },
    );
  };

  getVerificationLink = () => {
    const fetchUrl = `/customers/me/identity-verification-link`;

    return this.fetchCustom(
      fetchUrl, {});
  };
}

export default V3UserApi;
